import React from "react";
import { motion } from "framer-motion";
import { Eyebrow } from "@/components/Reveal";

export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="relative pt-40 pb-16 bg-ink overflow-hidden">
      <div className="absolute top-0 left-1/4 w-[600px] h-[400px] rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.08)_0%,transparent_65%)]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="font-serif font-light text-5xl sm:text-6xl tracking-tight mt-6 max-w-4xl leading-[1.02]">
            {title}
          </h1>
          {subtitle && (
            <p className="font-sans text-base sm:text-lg text-[#A19D98] leading-relaxed mt-7 max-w-2xl">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12">
        <div className="gold-hairline" />
      </div>
    </section>
  );
}
